import styled from 'styled-components';

export default styled.div`
  &::before {
    height: 70px;
    opacity: 0.3;
    font-size: 70px;
  }
`;
